import gql from 'graphql-tag';

import { DEAL_ACTIVITY_FRAGMENT } from './fragments/dealEventActivity.fragment';

export const RE_DATE_EVENT_ACTIVITIES = gql`
  mutation reDateEventActivities($input: ReDateEventActivitiesInput!) {
    dealActivity {
      result: reDateEventActivities(input: $input) {
        error
        success
        list {
          __typename
          ...DealEventActivityFields
        }
      }
    }
  }
  ${DEAL_ACTIVITY_FRAGMENT}
`;
